import "core-js/modules/es6.regexp.replace";
import Dialog from 'quasar/src/plugins/Dialog.js';import Loading from 'quasar/src/plugins/Loading.js';;
import { routerInstance } from 'boot/router';
import { i18nInstance as i18n } from 'src/boot/i18n'; // import voedsel from 'assetz/voedsel.json'
// import nestelgelegenheid from 'assets/nestelgelegenheid.json'
// import overleving from 'assets/overleving.json'
// import location from 'assets/location.json'
// import medals from 'assetz/medals.json'
// const mTypes = {
//     voedsel: voedsel,
//     nestelgelegenheid: nestelgelegenheid,
//     overleving: overleving,
//     location: location
// }

export var showErrorMessage = function showErrorMessage(errorMessage) {
  Loading.hide();
  Dialog.create({
    title: 'Error',
    message: errorMessage
  });
}; // export var showNeedAuthMessage2 = () => {
//     Dialog.create({
//         title: 'Niet aangemeld',
//         message: 'U dient aangemeld te zijn om gebieden te kunnen toevoegen'
//     })
// }

export var showNeedAuthMessage = function showNeedAuthMessage() {
  Dialog.create({
    nocaps: true,
    title: i18n.t('labels.account_required'),
    message: i18n.t('messages.add_area_account_required'),
    cancel: {
      flat: true,
      // icon: 'keyboard_arrow_left',
      'no-caps': true,
      // label: 'sluit'
      label: ''
    },
    ok: {
      flat: true,
      'no-caps': true,
      label: i18n.t('buttons.goto_authenticate')
    }
  }).onOk(function () {
    console.log('>>>> OK');
    routerInstance.replace({
      name: 'welcome'
    });
  }).onOk(function () {
    console.log('>>>> second OK catcher');
  }).onCancel(function () {
    console.log('>>>> Cancel');
  }).onDismiss(function () {
    console.log('I am triggered on both OK and Cancel');
  });
}; // // state.measures.filter(measure => measure.createdBy === state.user.id)
// export var getMeazure = (measure) => {
//     let meazureId = measure.properties.meazureId
//     // /* eslint-disable */
//     // let meazureType = eval(measure.properties.type)
//     // /* eslint-enable */
//     let result = mTypes[measure.properties.type].find(meazure => meazure.id === meazureId)
//     // console.log('res---------->', res)
//     return result
// }
//
// export var getMedals = (medalKeys) => {
//     // let meazureId = measure.properties.meazureId
//     // /* eslint-disable */
//     // let meazureType = eval(measure.properties.type)
//     // /* eslint-enable */
//     let result = medals.filter(medal => medalKeys.includes(medal.id))
//     console.log('res----------> MEDALS', result)
//     return result
// }